// Contact Support content. Static — no backend: a Helpdesk link, the support mailbox, and
// the running app version (so a reported issue can be pinned to a build). Carried over
// verbatim from the legacy Bootstrap modal (Modal/ContactSupport/ContactSupport.js) that the
// rail sidebar replaced. Sibling of feedback.ts, which owns the client Typeform entry point.
export const HELPDESK_URL =
  'https://www.notion.so/cloudcfoph/278db69b4c2d8030b354f2ef567de446?pvs=106';

export const SUPPORT_EMAIL = 'support@cloudcfo.ph';
